import React, { useState, useEffect } from 'react';
import './SurveyResponsesSurveyDistributionCard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';
import { format, parseISO } from 'date-fns';

export default function SurveyResponsesSurveyDistributionCard({ surveyDistribution, selected, onClick }) {

  if (logComponent('SurveyResponsesSurveyDistributionCard')) { console.debug('SurveyResponsesSurveyDistributionCard rendered'); }


  const handleClick = () => {
    if (logComponent('SurveyResponsesSurveyDistributionCard')) { console.debug('SurveyResponsesSurveyDistributionCard handleClick'); }
    onClick(surveyDistribution);
  }

  return (
    <li className={'Survey-Responses-Survey-Distribution-Card' + (selected ? ' Survey-Responses-Survey-Distribution-Card--selected' : '')}>
      <button onClick={handleClick}>

        <p className="Survey-Responses-Survey-Distribution-Card__name">{`Distribution`}</p>
        {/*<p className="Survey-Responses-Survey-Distribution-Card__name">{`Message:  ${surveyDistribution.message}`}</p>*/}
        <p className="Survey-Responses-Survey-Distribution-Card__date">{`Start on: ${format(parseISO(surveyDistribution.sendOn), 'MM/dd/yyyy') }`}</p>
        <p className="Survey-Responses-Survey-Distribution-Card__date">{`End on: ${format(parseISO(surveyDistribution.expiresOn), 'MM/dd/yyyy') }`}</p>
      </button>
    </li>
  );
}

